import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Typography,
  notification,
  Switch,
  Menu,
  Input,
  Dropdown,
   Modal
} from "antd";

import { SearchOutlined , DownOutlined } from "@ant-design/icons";

// Images
import { getAirports, getAirportDetail, toggleAirportStatus, deleteAirport } from "../api/airport.service";
import { useEffect, useState } from "react";
import moment from "moment";
import EditAirportFormModal from "../components/forms/airport/EditAirportFormModal";
import AddAirportFormModal from "../components/forms/airport/AddAirportFormModal";

const { Title } = Typography

function Airports() {

  const onChangeStatus = async (checked, record) => {
    let updated = {
      ...record,
      status: checked ? 1 : 0
    }

    try {
      await toggleAirportStatus(updated)
      notification.success({
        message: 'Status updated'
      })
      fetchAirports();
    } catch (error) {
      notification.error({
        message: 'Operation failed'
      })
    }
  };

  const handleConfirm = async (id) => {
    try {
      const data = await deleteAirport(id);
      
        notification.success({ message: 'Airport deleted successfully' });
        fetchAirports();
      
    } catch (err) {
      notification.error({ message: 'Failed to delete airport' });
    }
  }

  const getAirportDataDelete = async (id) => {
    Modal.confirm({
      title: "Warning",
      content: "Are you sure you want to delete this?",
      okText: "Confirm",
      cancelText: "Cancel",
      onOk() {
        handleConfirm(id)
      },
      onCancel() {
        console.log("Cancelled");
      },
    });
  }

  // Helper function to add search functionality
  const getColumnSearchProps = (dataIndex, placeholder, renderField) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${placeholder}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => confirm()}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      const recordValue = renderField ? renderField(record) : record[dataIndex];
      return recordValue
        ? recordValue.toString().toLowerCase().includes(value.toLowerCase())
        : false;
    },
  });

  const columns = [
    {
      title: "AIRPORT NAME",
      dataIndex: "airportName",
      key: "airportName",
      width: "35%",
      ...getColumnSearchProps("airportName", "Airport Name", (record) => record.airportName),
      render: (text, record) => (
        <div className="avatar-info">
          <Title level={5}>{record.airportName}</Title>
        </div>
      ),
    },
    {
      title: "AIRPORT CODE",
      dataIndex: "airportCode",
      key: "airportCode",
      width: "25%",
      ...getColumnSearchProps("airportCode", "Airport Code", (record) => record.airportCode),
      render: (text, record) => (
        <div className="author-info">
          <Title level={5}>{record.airportCode}</Title>
        </div>
      ),
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
      width: "25%",
      render: (text, record) => (
        <div>
          <Switch
            defaultChecked={record.status === 1} // Set initial checked state
            onChange={(checked) => onChangeStatus(checked, record)}
          />
        </div>
      ),
    },
    {
      title: "ACTIONS",
      width: "25%",
      render: (text, record) => {
        const menu = (
          <Menu>
            <Menu.Item key="view" onClick={() => getAirportData(record.id, true)}>
              View
            </Menu.Item>
            <Menu.Item key="edit" onClick={() => getAirportData(record.id)}>
              Edit
            </Menu.Item>
            <Menu.Item key="delete" onClick={() => getAirportDataDelete(record.id)}>
              Delete
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menu}>
            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
              Tasks <DownOutlined />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const [airports, setAirports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  const [airportData, setAirportData] = useState(null);
  const [isViewOnly, setisViewOnly] = useState(false);

  const fetchAirports = async () => {
    try {
      setLoading(true);
      const data = await getAirports();
      const sorted = (data?.data || []).slice().sort((a, b) => {
        const nameA = (a?.airportName || '').toString();
        const nameB = (b?.airportName || '').toString();
        return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
      });
      setAirports(sorted);
    } catch (err) {
      notification.error({ message: 'Failed to fetch airports' });
      setError('Failed to fetch airports');
    } finally {
      setLoading(false);
    }
  };

  const getAirportData = async (id, isViewOnly = false) => {
    setisViewOnly(isViewOnly)
    const data = await getAirportDetail(id);
    setAirportData(data?.data);
    setIsModalOpenEdit(true);
  }

  useEffect(() => {
    fetchAirports();
  }, []);

  const onChange = (e) => console.log(`radio checked:${e.target.value}`);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOkEdit = () => {
    setIsModalOpenEdit(false);
  };

  const handleCancelEdit = () => {
    setIsModalOpenEdit(false);
  };

  return (
    <>
      {airportData && <EditAirportFormModal isViewOnly={isViewOnly} airportData={airportData} fetchAirports={fetchAirports} handleCancel={handleCancelEdit} handleOk={handleOkEdit} isModalOpen={isModalOpenEdit} setIsModalOpen={setIsModalOpenEdit} />}
      <AddAirportFormModal fetchAirports={fetchAirports} handleCancel={handleCancel} handleOk={handleOk} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      <div className="mb-3 flex justify-end">
        <Button type="primary" onClick={showModal}>
          Add Airport
        </Button>
      </div>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Airports Table"
            >
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={airports}
                  pagination={{
                    pageSize: 100
                  }}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Airports;
